export default {
  newLineTitle: 'Invoice new line',
  tableActionText: 'Press "add" to add a new element',
  title: 'Invoice details',
  confirmDeleteLine: 'By deleting a line you will lose the information you have entered. Do you want to delete it?',
  deleteLine: 'Delete line',
  noData: 'No data available',
  headers: {
    description: 'Description',
    quantity: 'Quantity',
    amount: 'Amount',
    rebate: 'Rebate/Charges',
    taxes: 'Taxes',
    subtotal: 'Subtotal',
    type: 'Type',
    class: 'Class',
    percent: '(%)',
    taxType: 'Tax type',
    documentType: 'Document type',
    datum: 'Datum',
    reason: 'Reason',
    base: 'Base'
  },
  form: {
    actionText: '(Article 14, 143 of Law 37/1992, on VAT)',
    articleData: {
      title: 'Article data',
      vendorCode: 'Seller code',
      payerCode: 'Payer code',
      description: 'Description',
      priceBatch: 'Price by batch',
      quantity: 'Quantity',
      unit: 'Unit',
      batchUnits: 'Units by batch',
      search: 'Serach in catalog',
      tooltip: 'Required field if sending fixed assets'
    },
    resume: {
      title: 'Summary of quantites',
      totalBefore: 'Total before discounts/charges',
      totalDiscountsCharges: 'Total discounts/charges',
      totalTaxes: 'Total taxes',
      totalLine: 'Total line'
    },
    discountsCharges: {
      title: 'Discounts/Charges',
      validation: 'Fields to calculate the amount are not valid, check the price per batch values, quantity or unit per batch.'
    },
    taxes: {
      title: 'Taxes'
    },
    documents: {
      title: 'Associated documents',
      orderSender: 'Issuer order number',
      orderReceiver: 'Receiver order number'
    },
    deliveryNotes: {
      title: 'Delivery notes',
      validation: `The field 'Dato' must be alphanumeric.`
    },
    extraInfo: {
      title: 'Additional information',
      comments: 'Comments'
    },
    serisMandatori: 'Mandatory fields for invoices issued in the Riojan Health Service (SERIS)'
  }
}
